<template>

  <group-card title="Request Documents" icon="attachment" :loading="sending_email" :tooltipText="tooltipText">
    <document-requests-component v-model="applicant" :application="application" @loading="loading"></document-requests-component>
  </group-card>

</template>

<script>
import { mapGetters } from 'vuex';
import DocumentRequestsComponent from '@/components/Document/DocumentRequestsComponent';
import GroupCard from "@/components/Cards/GroupCard";

export default {
  data(){
    return {
      sending_email: false,
      tooltipText:'<table border="1"><tbody>'+
		'<tr><td>Full Time</td><td>Green</td><td>Drivers License/Government issues Photo ID</td><td>2x Most Recent Payslips</td></tr>'+
        '<tr><td>Full Time</td><td>Amber</td><td>Drivers License/Government issues Photo ID</td><td>2x Most Recent Payslips</td><td>3 Months Bank Statements</td></tr>'+
		'<tr><td>Part Time</td><td>Green</td><td>Drivers License/Government issues Photo ID</td><td>2x Most Recent Payslips</td></tr>'+
		'<tr><td>Part Time</td><td>Amber</td><td>Drivers License/Government issues Photo ID</td><td>2x Most Recent Payslips</td><td>3 Months Bank Statements</td></tr>'+
		'<tr><td>Casual</td><td>Green</td><td>Drivers License/Government issues Photo ID</td><td>2x Most Recent Payslips</td></tr>'+
		'<tr><td>Casual</td><td>Amber</td><td>Drivers License/Government issues Photo ID</td><td>2x Most Recent Payslips</td><td>3 Months Bank Statements</td></tr>'+
		'<tr><td>Self Employed</td><td>Green</td><td>Drivers License/Government issues Photo ID</td><td>6 Months Bank Statements</td></tr>'+
		'<tr><td>Self Employed</td><td>Amber</td><td>Drivers License/Government issues Photo ID</td><td>6 Months Bank Statements</td></tr>'+
	    '</tbody></table>'+
		'<li>If Self Employed – All Green please request documents required but can be distributed without documents</li>'+
		'<li>We only collect the applicants – document – if nominated driver must stay in same address – we do not upload their licence</li>'+
		'<li>Pension leads and no Veda leads require all documents</li>',
    };
  },
  components: {
    GroupCard,
    DocumentRequestsComponent
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    application: {
      type: Object,
      required: true,
    },
    index: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      options: 'options',
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get(){ return this.value },
      set(applicant){ this.$emit('input', applicant) },
    }
  },

  methods: {
    loading(value) {
      this.sending_email = value;
    },
  }

};
</script>
